import { NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ReactiveFormsModule } from '@angular/forms';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeuix/themes/lara';

// Import routing module
import { AppRoutingModule } from './app-routing.module';

// Import app component
import { AppComponent } from './app.component';
import { AgGridModule } from 'ag-grid-angular';

// Import containers
import { DefaultFooterComponent, DefaultHeaderComponent, DefaultLayoutComponent } from './containers';

import {
    AvatarModule,
    BadgeModule,
    BreadcrumbModule,
    ButtonGroupModule,
    ButtonModule,
    CardModule,
    DropdownModule,
    FooterModule,
    FormModule,
    GridModule,
    HeaderModule,
    ListGroupModule,
    NavModule,
    ProgressModule,
    SharedModule,
    SidebarModule,
    TabsModule,
    UtilitiesModule,
} from '@coreui/angular';

import { IconModule, IconSetService } from '@coreui/icons-angular';
import { CampaignroleModule } from './modules/campaignrole/campaignrole.module';
import { DemoroleModule } from './modules/demorole/demorole.module';
import { NewRandomModule } from './modules/newrandom/newrandom.module';
import { RetryrandomModule } from './modules/retryrandom/retryrandom.module';
import { HistoryrandomModule } from './modules/historyrandom/historyrandom.module';
import { PooldataModule } from './modules/pooldata/pooldata.module';
import { ApilogModule } from './modules/apilog/apilog.module';
import { ConfigModule } from './modules/config/config.module';
import { ShareModule } from './share.module';
import { ImportpooldataModule } from './modules/importpooldata/importpooldata.module';
import { environment } from 'src/environments/environment';
import { LogoutModule } from './modules/logout/logout.module';
import { MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { MsalLoginModule } from './modules/msal-login/msal-login.module';
import { EntraTokenInterceptor } from './core/interceptor/entra-token.interceptor';

const APP_CONTAINERS = [DefaultFooterComponent, DefaultHeaderComponent, DefaultLayoutComponent];

@NgModule({ declarations: [AppComponent, ...APP_CONTAINERS],
    bootstrap: [AppComponent, MsalRedirectComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        AvatarModule,
        BreadcrumbModule,
        FooterModule,
        DropdownModule,
        GridModule,
        HeaderModule,
        SidebarModule,
        IconModule,
        NavModule,
        ButtonModule,
        FormModule,
        UtilitiesModule,
        ButtonGroupModule,
        ReactiveFormsModule,
        SidebarModule,
        SharedModule,
        TabsModule,
        ListGroupModule,
        ProgressModule,
        BadgeModule,
        ListGroupModule,
        CardModule,
        DashboardModule,
        DemoroleModule,
        NewRandomModule,
        RetryrandomModule,
        HistoryrandomModule,
        PooldataModule,
        CampaignroleModule,
        ApilogModule,
        NgxSpinnerModule,
        AgGridModule,
        ConfigModule,
        ShareModule,
        ImportpooldataModule,
        LogoutModule,
        MsalLoginModule], providers: [
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy,
        },
        IconSetService,
        Title,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: EntraTokenInterceptor,
            multi: true,
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        providePrimeNG({ theme: { preset: Lara, options: { darkModeSelector: 'none' } } }),
    ] })
export class AppModule {}
